// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

export const vAggregationOperator = v.picklist([
  'max',
  'min',
  'geoBounds',
  'count',
  'distinct',
]);

export const vClause = v.record(v.string(), v.unknown());

export const vCodeType = v.picklist([
  'genericError',
  'unsupportedFileType',
  'importSummary',
  'zippedFileImportSummary',
  'errorStoringData',
  'noFeaturesInFile',
  'noGeometriesInFile',
  'incompatibleDatums',
  'layerDatumComponentIdNotFound',
  'layerDatumParseFailure',
  'shapefileFileMissing',
  'shapefileFileDuplicated',
  'shapefilePrjCouldNotBeRead',
  'shapefileGeometryNull',
  'keyholeMarkupLanguageError',
  'keyholeGeometryNull',
  'keyholeGeometryLinearRingInvalid',
  'keyholeCoordinateOutOfRange',
  'fileGeodatabaseAttributeTypeNotSupported',
  'fileGeodatabaseAttachementTablesNotSupported',
  'fileGeodatabaseEditorTrackingNotSupported',
  'fileGeodatabaseUnsupportedGeometryType',
  'fileGeodatabaseErrorConvertingAttributeValue',
  'fileGeodatabaseGeometryNull',
  'fileGeodatabaseLinearRingInvalid',
  'fileGeodatabaseUnsupportedVersion',
  'zipDeserializerSkippingZipFileWithinZipFile',
  'zippedChildFileMessages',
  'trimbleAccessMarkupLanguageError',
  'layerContainsAllNullGeometries',
]);

export const vCoerceType = v.picklist(['text', 'number', 'dateTime']);

export const vAggregation = v.object({
  operator: v.optional(vAggregationOperator),
  field: v.optional(v.union([v.null(), v.string()])),
  filter: v.optional(v.union([v.null(), v.array(vClause)])),
  type: v.optional(v.union([v.null(), vCoerceType])),
});

export const vBulkAggregation = v.object({
  aggregations: v.optional(v.union([v.null(), v.object({})])),
});

export const vCoordinateType = v.picklist(['original', 'local', 'global']);

export const vDeletionStatus = v.picklist(['activeOnly', 'deletedOnly', 'all']);

/**
 * geometry
 *
 * http://geojson.org/geojson-spec.html#geometry-objects
 */
export const vGeometry = v.object({
  coordinates: v.optional(v.array(v.pipe(v.array(v.number()), v.minLength(2)))),
  type: v.optional(v.string()),
});

export const vIFormFile = v.string();

export const vProject = v.object({
  id: v.optional(v.union([v.null(), v.string()])),
  name: v.optional(v.union([v.null(), v.string()])),
  hasTenancy: v.optional(v.boolean()),
});

export const vProperty = v.object({
  name: v.optional(v.union([v.null(), v.string()])),
});

export const vNamedCrs = v.object({
  type: v.optional(v.union([v.null(), v.string()])),
  properties: v.optional(vProperty),
});

export const vFeature = v.object({
  type: v.optional(v.union([v.null(), v.string()])),
  id: v.optional(v.union([v.null(), v.pipe(v.string(), v.uuid())])),
  geometry: v.optional(vGeometry),
  properties: v.optional(
    v.union([v.null(), v.record(v.string(), v.unknown())])
  ),
  tags: v.optional(v.union([v.null(), v.array(v.string())])),
  metadata: v.optional(v.union([v.null(), v.record(v.string(), v.unknown())])),
  crs: v.optional(vNamedCrs),
});

export const vFeatureCollection = v.object({
  type: v.optional(v.union([v.null(), v.string()])),
  features: v.optional(v.union([v.null(), v.array(vFeature)])),
  metadata: v.optional(v.union([v.null(), v.record(v.string(), v.unknown())])),
  crs: v.optional(vNamedCrs),
  schema: v.optional(v.union([v.null(), v.record(v.string(), v.unknown())])),
  total: v.optional(
    v.union([
      v.null(),
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ])
  ),
  startIndex: v.optional(
    v.union([
      v.null(),
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ])
  ),
  pageSize: v.optional(
    v.union([
      v.null(),
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ])
  ),
  scrollId: v.optional(v.union([v.null(), v.pipe(v.string(), v.uuid())])),
  eTags: v.optional(v.union([v.null(), v.record(v.string(), v.string())])),
});

export const vSeverityType = v.picklist(['warning', 'error']);

export const vCodedError = v.object({
  severity: v.optional(vSeverityType),
  code: v.optional(vCodeType),
  parameters: v.optional(
    v.union([v.null(), v.record(v.string(), v.unknown())])
  ),
  debugMessageText: v.optional(v.union([v.null(), v.string()])),
});

export const vImportResult = v.object({
  messages: v.optional(v.array(vCodedError)),
  apiRequestId: v.optional(v.string()),
  filename: v.optional(v.string()),
  fileVersionId: v.optional(v.string()),
  serverDateTime: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  isComplete: v.optional(v.boolean()),
  sourceLayerNames: v.optional(v.array(v.string())),
  layerStyles: v.optional(v.array(v.string())),
  importId: v.optional(v.string()),
});

export const vSortOrder = v.picklist(['ascending', 'descending']);

export const vSortBy = v.object({
  field: v.optional(v.union([v.null(), v.string()])),
  order: v.optional(vSortOrder),
  type: v.optional(vCoerceType),
});

export const vQuery = v.object({
  filter: v.optional(v.union([v.null(), v.array(vClause)])),
  sortBy: v.optional(v.union([v.null(), v.array(vSortBy)])),
  fields: v.optional(v.union([v.null(), v.array(v.string())])),
  coordinateType: v.optional(vCoordinateType),
  initialScrolledRequestCrs: v.optional(vNamedCrs),
  includeSchema: v.optional(v.boolean()),
  startIndex: v.optional(
    v.union([
      v.null(),
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ])
  ),
  pageSize: v.optional(
    v.union([
      v.null(),
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ])
  ),
  deletionStatus: v.optional(vDeletionStatus),
});

/**
 * Size of tiles from tiling service
 */
export const vTileSize = v.picklist(['standard256', 'large512']);

/**
 * Trimble Standard Error Payload. Extends RFC 9457 Problem Details with referenceId for troubleshooting.
 */
export const vTrimbleProblemDetails = v.object({
  type: v.pipe(v.string(), v.url()),
  title: v.string(),
  status: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
    v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
  ),
  detail: v.optional(v.string()),
  instance: v.optional(v.pipe(v.string(), v.url())),
  referenceId: v.optional(v.string()),
  errors: v.optional(
    v.array(
      v.object({
        type: v.optional(v.string()),
        title: v.optional(v.string()),
      })
    )
  ),
});

export const vGetProjectsByProjectIdFeaturesAggregationsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      field: v.optional(v.string()),
      aggregation: v.optional(vAggregationOperator),
      filter: v.optional(v.string()),
      type: v.optional(vCoerceType),
    })
  ),
});

export const vPutProjectsByProjectIdFeaturesAggregationsData = v.object({
  body: vBulkAggregation,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vPutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedData =
  v.object({
    body: v.array(v.string()),
    path: v.object({
      projectId: v.string(),
    }),
    query: v.optional(v.never()),
  });

export const vDeleteProjectsByProjectIdFeaturesMetadataData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      metadataPropertyName: v.optional(v.string()),
    })
  ),
});

export const vPatchProjectsByProjectIdFeaturesMetadataData = v.object({
  body: v.record(v.string(), v.unknown()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
    })
  ),
});

export const vDeleteProjectsByProjectIdFeaturesData = v.object({
  body: vFeatureCollection,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectsByProjectIdFeaturesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      coordinateType: v.optional(vCoordinateType, 'original'),
      filter: v.optional(v.string()),
      start: v.optional(
        v.union([
          v.pipe(
            v.number(),
            v.integer(),
            v.minValue(
              -2147483648,
              'Invalid value: Expected int32 to be >= -2^31'
            ),
            v.maxValue(
              2147483647,
              'Invalid value: Expected int32 to be <= 2^31-1'
            )
          ),
          v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
        ])
      ),
      size: v.optional(
        v.union([
          v.pipe(
            v.number(),
            v.integer(),
            v.minValue(
              -2147483648,
              'Invalid value: Expected int32 to be >= -2^31'
            ),
            v.maxValue(
              2147483647,
              'Invalid value: Expected int32 to be <= 2^31-1'
            )
          ),
          v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
        ])
      ),
      schema: v.optional(v.boolean()),
      sortBy: v.optional(v.string()),
      fields: v.optional(v.string()),
      deletionStatus: v.optional(vDeletionStatus, 'activeOnly'),
    })
  ),
});

/**
 * OK
 */
export const vGetProjectsByProjectIdFeaturesResponse = vFeatureCollection;

export const vPatchProjectsByProjectIdFeaturesData = v.object({
  body: vFeatureCollection,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
});

/**
 * A FeatureCollection.
 */
export const vPatchProjectsByProjectIdFeaturesResponse = vFeatureCollection;

export const vPostProjectsByProjectIdFeaturesData = v.object({
  body: vFeatureCollection,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
});

export const vPostProjectsByProjectIdFeaturesResponse = v.union([
  vFeatureCollection,
  v.void(),
]);

export const vDeleteProjectsByProjectIdFeaturesByIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDeleteProjectsByProjectIdFeaturesByIdResponse = v.void();

export const vGetProjectsByProjectIdFeaturesByIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      coordinateType: v.optional(vCoordinateType, 'original'),
      schema: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vGetProjectsByProjectIdFeaturesByIdResponse = vFeatureCollection;

export const vPutProjectsByProjectIdFeaturesQueryData = v.object({
  body: vQuery,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * A FeatureCollection.
 */
export const vPutProjectsByProjectIdFeaturesQueryResponse = vFeatureCollection;

export const vScrollFeaturesData = v.object({
  body: vQuery,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      scrollId: v.optional(v.pipe(v.string(), v.uuid())),
    })
  ),
});

/**
 * A FeatureCollection.
 */
export const vScrollFeaturesResponse = vFeatureCollection;

export const vPostProjectsByProjectIdFeaturesDeleteData = v.object({
  body: vFeatureCollection,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vPutProjectsByProjectIdFeaturesLayersLayerGeomTypeData = v.object({
  body: v.array(v.string()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vPutProjectsByProjectIdFeaturesLayersLayerGeomTypeResponse =
  v.record(v.string(), v.string());

export const vPostProjectsByProjectIdFeaturesImportsData = v.object({
  body: v.intersect([
    v.object({
      csId: v.optional(v.string()),
    }),
    v.object({
      file: v.optional(vIFormFile),
    }),
    v.object({
      metadata: v.optional(v.record(v.string(), v.unknown())),
    }),
  ]),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      fileId: v.optional(v.string()),
    })
  ),
});

/**
 * An HTTP Status code indicating the status of the request, along with a ImportResult.
 */
export const vPostProjectsByProjectIdFeaturesImportsResponse = vImportResult;

export const vGetProjectsByProjectIdFeaturesImportsStatusData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
    })
  ),
});

export const vDeleteProjectsByProjectIdFeaturesTagsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      tag: v.optional(v.string()),
    })
  ),
});

export const vPatchProjectsByProjectIdFeaturesTagsData = v.object({
  body: vQuery,
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      tag: v.optional(v.string()),
    })
  ),
});

export const vGetProjectsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      nameLike: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vGetProjectsResponse = v.array(vProject);

export const vPostProjectsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      projectId: v.optional(v.string()),
    })
  ),
});

export const vDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vGetProjectResponse = vProject;

export const vGetProjectsByProjectIdTilesByZoomByXByYData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    zoom: v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ]),
    x: v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ]),
    y: v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ]),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      tileSize: v.optional(vTileSize, 'standard256'),
      filter: v.optional(v.string()),
      fields: v.optional(v.string()),
      timestamp: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    })
  ),
});

/**
 * The FeatureCollection occupying this tile.
 */
export const vGetProjectsByProjectIdTilesByZoomByXByYResponse =
  vFeatureCollection;

export const vGetProjectsByProjectIdFeaturesTilesByZoomByXByYData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    zoom: v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ]),
    x: v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ]),
    y: v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
    ]),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      tileSize: v.optional(vTileSize, 'standard256'),
      filter: v.optional(v.string()),
      fields: v.optional(v.string()),
      timestamp: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    })
  ),
});

/**
 * The FeatureCollection occupying this tile.
 */
export const vGetProjectsByProjectIdFeaturesTilesByZoomByXByYResponse =
  vFeatureCollection;

export const vGetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYData =
  v.object({
    body: v.optional(v.never()),
    path: v.object({
      layerId: v.string(),
      zoom: v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
      ]),
      x: v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
      ]),
      y: v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.pipe(v.string(), v.regex(/^-?(?:0|[1-9]\d*)$/)),
      ]),
      projectId: v.string(),
    }),
    query: v.optional(
      v.object({
        tileSize: v.optional(vTileSize, 'standard256'),
        filter: v.optional(v.string()),
        fields: v.optional(v.string()),
      })
    ),
  });

/**
 * The FeatureCollection occupying this tile.
 */
export const vGetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYResponse =
  vFeatureCollection;

export const vGetProjectsByProjectIdLayersByLayerIdLastModifiedData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    layerId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGetProjectsByProjectIdLayersByLayerIdLastModifiedResponse =
  v.record(v.string(), v.pipe(v.string(), v.isoTimestamp()));

export const vPutProjectsByProjectIdLayersLastModifiedData = v.object({
  body: v.array(v.string()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vPutProjectsByProjectIdLayersLastModifiedResponse = v.record(
  v.string(),
  v.pipe(v.string(), v.isoTimestamp())
);
